<template>
    <div class="archive">
        <div class="columns">
            <div class="column is-3"  style="text-align:center;">
                <Datepicker/>
            </div>
            <div class="column">
                <div class="text_container">
                    <div class="card" v-for="diary in diary_data" :key="diary.index">
                        <router-link :to="{ name: 'archive', params:{ id_year: year_path, id_month: month_path, id_day:diary.day }}">
                        <p><span style="font-weight:bold;font-size:1.1em">{{month_path}}月{{diary.day}}日
                            </span>
                            {{diary.length}}文字
                        </p>
                        <p style="padding-top:10px;">{{diary.message}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import Datepicker from '@/components/Datepicker.vue'
export default {
    name: 'home',
    components: {
        Datepicker
    },
    data() {
        return{
        day_counts: [],
        year_path: '',
        month_path: '',
        diary_data: [],
        }
    },
    computed:{
        today(){
        return this.$store.getters.today_info;
        },
        user(){
        return this.$store.getters.user;
        }
    },
    mounted(){
        const title = "月間アーカイブ｜エモーションダイアリー"
        const description = "月間アーカイブ画面"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },     
    watch: {
        '$route' (to) {
            this.$router.go(to.params.id)
        }
    },
    created(){
        var [ , , year_path, month_path] = location.pathname.split('/')
        this.year_path = year_path
        this.month_path = month_path

        firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).orderBy("day", "desc").get().then(snapshot => {
            snapshot.forEach(doc => {
            var data = doc.data()
            this.diary_data.push(data)
            })
        });
    },
    
}
</script>

<style scoped>
.archive{
    min-height: 400px;
    padding: 10px
}
.text_container{
    max-width: 800px;
}
.day_counts{
    display: inline;
    font-size: 1.3em;
    padding:2px;
    font-weight: bold;
}
.month{
    text-align: center;
}
.card{
    margin-bottom: 10px;
}
.card p{
    padding: 5px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
a{
    color:#515151;
}
</style>